module.exports = __webpack_public_path__ + "static/Banner-1-370280b489b26288c338cc2ff0a2a570.png";